import { render, staticRenderFns } from "./ChildrenSecondaryYN.vue?vue&type=template&id=c3234d4e"
import script from "./ChildrenSecondaryYN.vue?vue&type=script&lang=js"
export * from "./ChildrenSecondaryYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports